module.exports = __webpack_public_path__ + "img/safari.92e49db4.svg";